<template>
  <div class="context-header row">
    <div v-for="(value, name) in contextFields" class="col-sm-4">
      <template v-if="name === 'Referencia bibliográfica' || name === 'Referència bibliogràfica'">
        <b>{{name}}:</b> <span v-html="value"></span>
      </template>
      <template v-else>
        <b>{{name}}:</b> {{value}}
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useContextFields } from './context_fields'

const props = defineProps<{
  document: Record<string, any>,
  text: Record<string, any>,
  elements?: Record<string, any>,
  matches?: number[]
}>()

const contextFields = useContextFields(props.document, props.text, props.elements, props.matches)
</script>
